var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUz = function SvgUz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#55dd1504-b82b-4886-96e6-3b88f05483cca)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "43ee8592-6d82-481d-b11c-ded1316fb5b7b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#43ee8592-6d82-481d-b11c-ded1316fb5b7b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D4112A",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20BD42",
    fillRule: "evenodd",
    d: "M0 11h21v4H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02A3BD",
    fillRule: "evenodd",
    d: "M0 0h21v4H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 5h21v5H0zm5-1.085a1.5 1.5 0 1 1 0-2.83 1.5 1.5 0 0 0 0 2.83",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78CDDB",
    fillRule: "evenodd",
    d: "M6 2h1v1H6zm1-1h1v1H7zm1 1h1v1H8zm1-1h1v1H9zm1 1h1v1h-1zM9 3h1v1H9zM7 3h1v1H7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "55dd1504-b82b-4886-96e6-3b88f05483cca"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgUz;